var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.items.length == 0
        ? _c(
            "div",
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-5 d-flex justify-center",
                      attrs: { cols: "2", sm: "6", md: "5" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#0154A6",
                            outlined: "",
                            disabled: _vm.items.length == _vm.maxItems
                          },
                          on: { click: _vm.addItem }
                        },
                        [
                          _c("span", { staticClass: "d-none d-sm-flex mr-3" }, [
                            _vm._v(_vm._s(_vm.addButton))
                          ]),
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(_vm._s(_vm.icon))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-scroll-y-transition",
        { attrs: { group: "" } },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            { key: item },
            [
              _c(
                "v-row",
                { staticClass: "mr-2", attrs: { align: "stretch" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "10", sm: "11" } },
                    [
                      _vm._t("default", null, {
                        isFormComplete: _vm.isFormComplete,
                        oldItem: _vm.oldItems[index],
                        selectedValues: _vm.selectedValues
                      })
                    ],
                    2
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2", sm: "1" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "start" } },
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: _vm.items.length == _vm.minItems,
                                    small: "",
                                    color: "error"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteItem(index)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { medium: "" } }, [
                                    _vm._v("mdi-close")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.items.length - 1 == index
                ? _c(
                    "v-row",
                    { attrs: { align: "center", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-5",
                          attrs: { cols: "2", sm: "6", md: "5" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.items.length == _vm.maxItems,
                                color: "#0154A6",
                                outlined: ""
                              },
                              on: { click: _vm.addItem }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "d-none d-sm-flex mr-3" },
                                [_vm._v(_vm._s(_vm.addButton))]
                              ),
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(_vm._s(_vm.icon))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.divider
                ? _c("v-row", [_c("v-col", [_c("v-divider")], 1)], 1)
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }